var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-3"},[_c('div',{staticClass:"row"},[_c('LocationShiftTime',{ref:"manageLocShiftTimeControl",on:{"event-edittime":_vm.onChangeTime}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ManageShiftProcedure',{ref:"manageLocShiftProcControl"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1ea456","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shift/location-shift-edit.vue
// module id = 1125
// module chunks = 0